<div class="content">
  <div>
    <div nz-row nzType="flex" class="summary-section">
      <app-sectors-and-industries-summary></app-sectors-and-industries-summary>
    </div>
  </div>
  <div class="details-section">
    <div nz-row nzType="flex" nzGutter="25" style="display: flex;">
      <div nz-col nzSpan="6" class="sector-col">
        <div class="sector-block">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="11"
            [sectorName]="sectorMetaDta[11].sector_name"
            [imageName]="'consumer-goods'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="12"
            [sectorName]="sectorMetaDta[12].sector_name"
            [imageName]="'consumer-services'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="21"
            [sectorName]="sectorMetaDta[21].sector_name"
            [imageName]="'cross-sector'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
      </div>
      <div nz-col nzSpan="6" class="sector-col">
        <div class="sector-block">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="13"
            [sectorName]="sectorMetaDta[13].sector_name"
            [imageName]="'energy'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="17"
            [sectorName]="sectorMetaDta[17].sector_name"
            [imageName]="'financials'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="20"
            [sectorName]="sectorMetaDta[20].sector_name"
            [imageName]="'health-care'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
      </div>
      <div nz-col nzSpan="6" class="sector-col">
        <div class="sector-block">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="16"
            [sectorName]="sectorMetaDta[16].sector_name"
            [imageName]="'industrials'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="19"
            [sectorName]="sectorMetaDta[19].sector_name"
            [imageName]="'materials'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
      </div>
      <div nz-col nzSpan="6" class="sector-col">
        <div class="sector-block">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="15"
            [sectorName]="sectorMetaDta[15].sector_name"
            [imageName]="'technology'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="14"
            [sectorName]="sectorMetaDta[14].sector_name"
            [imageName]="'telecomunications'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
        <div class="sector-block top-margin">
          <app-sector-details
            *ngIf="sectorMetaReady"
            [sectorId]="18"
            [sectorName]="sectorMetaDta[18].sector_name"
            [imageName]="'utilities'"
            [hasCompsAccess]="hasCompsAccess"
          >
          </app-sector-details>
        </div>
      </div>
    </div>
  </div>
</div>
